import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AccordionModule } from '@purespectrum1/ui/accordion';
import { ButtonModule } from '@purespectrum1/ui/button';
import { ModalModule } from '@purespectrum1/ui/modal';
import { TableModule } from '@purespectrum1/ui/table';

import { AlertModule } from '../../shared/ui/alert/alert.module';
import { InputWithConfirmationModule } from '../../shared/ui/input-with-confirmation/input-with-confirmation.module';

import { MultiQuotaNestingModalComponent } from './multi-quota-nesting-modal.component';
import { MultiQuotaNestingSelectionComponent } from './multi-quota-nesting-selection/multi-quota-nesting-selection.component';
import { MultiQuotaNestingTableComponent } from './multi-quota-nesting-table/multi-quota-nesting-table.component';
import { InputRestrictionModule } from '../shared/ui/input-restriction/input-restriction.module';

@NgModule({
  declarations: [
    MultiQuotaNestingModalComponent,
    MultiQuotaNestingSelectionComponent,
    MultiQuotaNestingTableComponent,
  ],
  imports: [
    CommonModule,
    ModalModule,
    AccordionModule,
    TableModule,
    FormsModule,
    ButtonModule,
    InputWithConfirmationModule,
    AlertModule,
    InputRestrictionModule,
  ],
  exports: [],
})
export class MultiQuotaNestingModalModule {}
